import { render, staticRenderFns } from "./task-pannel.vue?vue&type=template&id=30c46e65&scoped=true&"
import script from "./task-pannel.vue?vue&type=script&lang=js&"
export * from "./task-pannel.vue?vue&type=script&lang=js&"
import style0 from "./task-pannel.vue?vue&type=style&index=0&id=30c46e65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c46e65",
  null
  
)

export default component.exports